import { Type } from 'typebox';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const NoteEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.note),
        noteType: Type.Optional(Type.String()),
        pleaseBring: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        pleaseBringIds: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        feeling: Type.Optional(Type.String()),
        feelings: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        question: Type.Optional(Type.String()),
        questionId: Type.Optional(Type.String({ minLength: 1 })),
        answer: Type.Optional(Type.String()),
        answerType: Type.Optional(Type.String()),
        cGoalLabels: Type.Optional(Type.Array(Type.String({ minLength: 1 })))
    })
]));
